
<script>
  import { setContext, onMount, afterUpdate  } from "svelte";
  import { WIZARD } from "./context.js";
  import { writable } from "svelte/store";

  export let onNext = null;
  export let onBack = null;
  export let startingStep = null;
  export let onValidate = null;
  export let onSubmit = null;
  export let onBeforeNavigating = null;
  let isLoading = false;
  
  const activeStep = writable(null);
  const isFinished = writable(false);
  const steps = writable([]);

  const previousScreen = () => {
    if ($activeStep.index == 0) return;

    const currentStep = $activeStep.key;
    const nextStep = $steps[$activeStep.index - 1];

    if (onBeforeNavigating && !onBeforeNavigating(currentStep, nextStep.key, 'previous'))
      return;

    $activeStep = nextStep;

    if (onBack) onBack(currentStep, nextStep.key);
  };

  const nextScreen = async () => {
    
    isLoading = true;
    //validate when going forward
    if (onValidate){
      let onValidateResult = onValidate( $activeStep.key, 'self');
      let isValidatePromise = onValidateResult instanceof Promise;
      if (isValidatePromise && !await onValidateResult){
        isLoading = false;
        return;
      }
      else if (!onValidateResult){
        isLoading = false;
        return;
      }
    }
    if ($activeStep.index < $steps.length - 1) {
      const currentStep = $activeStep.key;
      const nextStep = $steps[$activeStep.index + 1];

      if (onBeforeNavigating)
      {
        let onBeforeNavResult = onBeforeNavigating(currentStep, nextStep.key, 'next');
        let isBeforeNavPromise = onBeforeNavResult instanceof Promise;

        if ( (isBeforeNavPromise && !await onBeforeNavResult) || !onBeforeNavResult )
        {
          isLoading = false;
          return;
        }
      }

      if (onNext) {        
        let onNextResult = onNext(currentStep, nextStep.key)
        let isPromise = onNextResult instanceof Promise;
 
        if (isPromise && !await onNextResult) return;
        else if (!onNextResult) return;
      }
      isLoading = false;   
      $activeStep = nextStep;   
     
    }
  };

  const goToStep = async (newStep) => {  
    isLoading = false;
    let previousIndex = newStep.index - 1;
    if (previousIndex > -1) 
    {   
      if (onValidate) 
      {
        let onValidateResult =  onValidate($steps[newStep.index - 1].key, 'previous');
        let isValidatePromise = onValidateResult instanceof Promise;
        if ((isValidatePromise && !await onValidateResult) || (!onValidateResult)) 
        {
          await goToStep($steps[newStep.index - 1]);
          return;      
        } 
      }
    }

    if (onBeforeNavigating)
    {
      let onBeforeNavResult = onBeforeNavigating($activeStep ? $activeStep.key : null, newStep.key, 'load');
      let isBeforeNavPromise = onBeforeNavResult instanceof Promise;

      if ( (isBeforeNavPromise && !await onBeforeNavResult ) || !onBeforeNavResult )
        return;
    }

    $activeStep = newStep;
  };

  const submit = async () => {
    isLoading = true;
    let onValidateResult =  onValidate($activeStep.key, 'self');
    let isValidatePromise = onValidateResult instanceof Promise;

    if ((isValidatePromise && !await onValidateResult) || (!onValidateResult)) 
      {
        // await goToStep($steps[$activeStep.index ]);
        isLoading = false;
        return; 
      }  

    let onSubmitResult =  onSubmit();
    let isSubmitPromise = onSubmitResult instanceof Promise;
    
    if ((isSubmitPromise && onSubmitResult) || !onSubmitResult)
      $isFinished = true;

    isLoading = false;
  };

  const getStepByKey = (key) => {
    return $steps.find((s) => s.key == key);
  };

  $: isLastStep = $activeStep && $activeStep.index == $steps.length - 1;

  const registerStep = (step) => {
    steps.update((s) => {
      step.index = s.length;
      s.push(step);
      return s;
    });
  };

  setContext(WIZARD, {
    activeStep,
    isFinished,
    registerStep,
  });

  onMount(async() => {
    if(startingStep == null || startingStep == $steps[0].key)
    $activeStep = $steps[0]    
    else
      await goToStep(getStepByKey(startingStep));
  });

  afterUpdate(()=>{
    if ($activeStep != null && startingStep != $activeStep.key){
      goToStep(getStepByKey(startingStep));
    }
  });
</script>

<div>
  {#if !$isFinished}
    <ul class="progressbar">
      {#each $steps as step}
        <li
          style="width:{100 / $steps.length}%"
          class:active={step == $activeStep}
          on:click={goToStep.bind(this, step)}
        >
          <i class={step.icon} />
          <strong> {step.title} </strong>
        </li>
      {/each}
    </ul>
  {/if}

  <slot />

  {#if !$isFinished}
    <div class="row" style="margin-top:10px">
      {#if $activeStep && $activeStep.index > 0}
        <div class="col">
          <button class="btn btn-grey" on:click={previousScreen}
            ><i class="fas fa-chevron-left" />
            Back</button>
        </div>
      {/if}
      {#if $activeStep && $activeStep.index < $steps.length - 1 && $activeStep.showNextButton}
        <div class="col text-right">
          <button disabled={isLoading} class="btn btn-primary" on:click={nextScreen} style="width: 73px; height: 35px;" >
            {#if isLoading}
              <span class="spinner-border spinner-border-sm" />
            {:else}
              Next
              <i class="fas fa-chevron-right" />
            {/if}
            </button>
        </div>
      {/if}
      {#if $activeStep && $activeStep.index == $steps.length - 1}
        <div class="col text-right">
          <button class="btn btn-primary" on:click={submit}>Finish set up </button>
        </div>
      {/if}
    </div>
  {/if}
</div>

<style>
  .row {
    margin-bottom: 1em;
  }

  .progressbar {
    margin-bottom: 30px;
    overflow: hidden;
    color: lightgrey;
    padding-left: 0px;
    text-align: center;
  }

  .progressbar .active {
    color: #000000;
  }

  .progressbar li {
    list-style-type: none;
    font-size: 12px;
    float: left;
    position: relative;
    cursor: pointer;
  }

  .progressbar li i {
    width: 50px;
    height: 50px;
    line-height: 45px;
    display: block;
    font-size: 18px;
    color: #ffffff;
    background: lightgray;
    border-radius: 50%;
    margin: 0 auto 10px auto;
    padding: 2px;
  }

  .progressbar li:after {
    content: "";
    width: 100%;
    height: 2px;
    background: lightgray;
    position: absolute;
    left: 0;
    top: 25px;
    z-index: -1;
  }

  .progressbar li.active i,
  .progressbar li.active:after {
    background: #66D7D1;
  }
</style>
